import { ref } from 'vue'

import { trueOnce } from '@/utils/use'

export const settingsTab = ref<string | null>(null)
export const settingsOpenedOnce = trueOnce(settingsTab)
